<template>
  <b-row>
    <b-col>
      <b-row v-if="detail.name">
        <b-col> <p class="detail-title"><strong> Navn: </strong></p> </b-col><b-col cols="8" sm="9" md="9"> <p class="detail-content">{{ detail.name }}</p> </b-col>
      </b-row>
      <b-row v-if="detail.service">
        <b-col> <p class="detail-title"><strong> Service: </strong></p> </b-col><b-col cols="8" sm="9" md="9"> <p class="detail-content">{{ detail.service }}</p> </b-col>
      </b-row>
      <b-row v-if="detail.expiration">
        <b-col> <p class="detail-title"> <strong> Udløb: </strong></p> </b-col><b-col cols="8" sm="9" md="9"> <p class="detail-content">{{ detail.expiration }}</p> </b-col>
      </b-row>
      <b-row v-if="detail.purpose">
        <b-col> <p class="detail-title"><strong> Formål:</strong></p> </b-col><b-col cols="8" sm="9" md="9"> <p class="detail-content">{{ detail.purpose }}</p> </b-col>
      </b-row>
      <b-row v-if="detail.else">
        <b-col> <p class="detail-title"><strong> Andet: </strong></p> </b-col><b-col cols="8" sm="9" md="9"> <p class="detail-content">{{ detail.else }}</p> </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CookieCollapseDetail',
  props: {
    detail: {
      type: Object,
      required: true,
    }
  }
};
</script>

<style lang="scss" scoped>
  .detail-title {
    font-size: $under-title;
  }

  .detail-content {
    font-size: $content;
  }
</style>